module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"eis-charlie-template","short_name":"eis-charlie","start_url":"/","background_color":"#ff829a","theme_color":"#ff829a","display":"minimal-ui","icon":"src/images/flavours/Joghurt-Kirsch.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"189f3c3a450763430921eabfa1d43306"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
